
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcons = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icons_bf66e52498f89faf__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "icons_bf66e52498f89faf__b"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#icons_bf66e52498f89faf__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  d: "m8.588 7 5.672-5.293a.952.952 0 0 0 0-1.414 1.128 1.128 0 0 0-1.516 0l-6.431 6a.952.952 0 0 0 0 1.414l6.431 6c.419.39 1.097.39 1.516 0a.952.952 0 0 0 0-1.414L8.588 7z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#icons_bf66e52498f89faf__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  d: "M2.588 7 8.26 1.707a.952.952 0 0 0 0-1.414 1.128 1.128 0 0 0-1.516 0l-6.431 6a.952.952 0 0 0 0 1.414l6.431 6c.419.39 1.097.39 1.516 0a.952.952 0 0 0 0-1.414L2.588 7z"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"14\" viewBox=\"0 0 16 14\">\r\n    <defs>\r\n        <filter id=\"g9ysm4im8a\">\r\n            <feColorMatrix in=\"SourceGraphic\" values=\"0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0\"/>\r\n        </filter>\r\n        <filter id=\"d7sowiwokb\">\r\n            <feColorMatrix in=\"SourceGraphic\" values=\"0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0\"/>\r\n        </filter>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g>\r\n                    <g filter=\"url(#g9ysm4im8a)\" transform=\"translate(-1024 -449) translate(985 428) translate(39 21)\">\r\n                        <g>\r\n                            <path fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" d=\"M2.588 7L8.26 1.707c.419-.39.419-1.024 0-1.414-.419-.39-1.097-.39-1.516 0l-6.431 6c-.419.39-.419 1.024 0 1.414l6.431 6c.419.39 1.097.39 1.516 0 .419-.39.419-1.024 0-1.414L2.588 7z\" transform=\"translate(6)\"/>\r\n                        </g>\r\n                    </g>\r\n                    <g filter=\"url(#d7sowiwokb)\" transform=\"translate(-1024 -449) translate(985 428) translate(39 21)\">\r\n                        <g>\r\n                            <path fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" d=\"M2.588 7L8.26 1.707c.419-.39.419-1.024 0-1.414-.419-.39-1.097-.39-1.516 0l-6.431 6c-.419.39-.419 1.024 0 1.414l6.431 6c.419.39 1.097.39 1.516 0 .419-.39.419-1.024 0-1.414L2.588 7z\"/>\r\n                        </g>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons.bf66e52498f89faf968a69761de19e6a.svg"),
        {
          React: SvgIcons,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      